export function createSecureSeed(): string {
  const values = new Uint32Array(4);
  crypto.getRandomValues(values);
  return [...values].map((value) => value.toString(16).padStart(8, '0')).join('');
}

function xmur3(value: string): () => number {
  let hash = 1779033703 ^ value.length;
  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 3432918353);
    hash = hash << 13 | hash >>> 19;
  }
  return () => {
    hash = Math.imul(hash ^ hash >>> 16, 2246822507);
    hash = Math.imul(hash ^ hash >>> 13, 3266489909);
    return (hash ^= hash >>> 16) >>> 0;
  };
}

function sfc32(a: number, b: number, c: number, d: number): () => number {
  return () => {
    a >>>= 0;
    b >>>= 0;
    c >>>= 0;
    d >>>= 0;
    const result = (a + b | 0) + d | 0;
    d = d + 1 | 0;
    a = b ^ b >>> 9;
    b = c + (c << 3) | 0;
    c = c << 21 | c >>> 11;
    c = c + result | 0;
    return (result >>> 0) / 4294967296;
  };
}

export function seededRandom(seed: string, namespace = 'default'): () => number {
  const hash = xmur3(`${namespace}:${seed}`);
  return sfc32(hash(), hash(), hash(), hash());
}

export function seededShuffle<T>(values: readonly T[], seed: string, namespace = 'shuffle'): T[] {
  const random = seededRandom(seed, namespace);
  const result = [...values];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const target = Math.floor(random() * (index + 1));
    [result[index], result[target]] = [result[target], result[index]];
  }
  return result;
}

export function shortSeed(seed: string): string {
  return seed.slice(0, 8).toUpperCase();
}
